import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AdresseModels} from '../models/adresse-models';
import {HelperService} from './helper.service';
import {MatDialog} from '@angular/material/dialog';
import {OrtAuswahlComponent} from '../home-layout/adressen/ort-auswahl/ort-auswahl.component';
import {UserAuthenticationService} from './user-authentication.service';
import {MessageBoxService} from './message-box.service';
import {TranslateService} from '@ngx-translate/core';


@Injectable({
    providedIn: 'root',
})
export class AdresseDataService {
    private objectListFields: AdresseModels.ObjektListField[] = [];
    private laender?: AdresseModels.Country[];

    constructor(private http: HttpClient,
                private userAuthService: UserAuthenticationService,
                private helperService: HelperService,
                public dialog: MatDialog,
                private svcMessageBox: MessageBoxService,
                private translate: TranslateService) {
        this.getCountries().subscribe({
            next: (res: AdresseModels.Country[] | undefined) => {
                this.laender = res;
            },
        });
    }

    getAnreden(nurKontaktAnreden: boolean): Observable<AdresseModels.AddressSalutation[]> {
        const headers = new HttpHeaders({
            Authorization: this.helperService.getSwissAuthorization(this.userAuthService.currentUserInfo),
        });

        const params: HttpParams = new HttpParams()
            .set('onlyContactSalutations', nurKontaktAnreden.toString())
            .set('mandatorID', this.userAuthService.currentUserInfo.mandantID);

        const options = {
            headers: headers, params: params,
        };

        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.get<AdresseModels.AddressSalutation[]>(url + '/Salutations', options);
    }

    /*TODO: get from server EN-2148*/
    async getZuHanden(arg0: boolean) {
        return ['Herr', 'Frau'];
    }

    getBriefanreden(nurKontaktBriefanreden: boolean): Observable<AdresseModels.AddressLetterSalutation[]> {
        const headers = new HttpHeaders({
            Authorization: this.helperService.getSwissAuthorization(this.userAuthService.currentUserInfo),
        });

        const params: HttpParams = new HttpParams()
            .set('onlyContactLetterSalutations', nurKontaktBriefanreden.toString())
            .set('mandatorID', this.userAuthService.currentUserInfo.mandantID);

        const options = {
            headers: headers, params: params,
        };

        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.get<AdresseModels.AddressLetterSalutation[]>(url + '/LetterSalutations', options);
    }

    getAddressTypes(): Observable<AdresseModels.AddressTypes[]> {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.get<AdresseModels.AddressTypes[]>(url + '/AdressTypen', this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo));
    }

    getCountries(): Observable<AdresseModels.Country[]> {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.get<AdresseModels.Country[]>(url + '/Countries', this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo));
    }

    getAdressStatus(): Observable<AdresseModels.AdressStatus[]> {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.get<AdresseModels.AdressStatus[]>(url + '/AdressStatus', this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo));
    }

    getAdressen(): Observable<AdresseModels.AddressListElement[]> {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.get<AdresseModels.AddressListElement[]>(url + '?Mandator=' + this.userAuthService.getCurrentAuthenticatedUser()?.mandatorID, this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo));
    }

    /*
    getAddressByID(adressID: string): Observable<AdresseModels.DetailAdresseElement> {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.get<AdresseModels.DetailAdresseElement>(url + '/byAddressID?AdressID=' + adressID, this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo));
    }*/

    public async getAddressByID(adressID: string): Promise<AdresseModels.DetailAdresseElement> {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return new Promise((resolve, reject) => {
            this.http.get<AdresseModels.DetailAdresseElement>(url + '/byAddressID?AdressID=' + adressID, this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo)).subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: (err) => {
                    reject();
                }
            });
        });
    }

    getAnsprechpartnerByID(adressID: string): Promise<AdresseModels.AnsprechPartnerListElement[]> {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return new Promise((resolve, reject) => {
            this.http.get<AdresseModels.AnsprechPartnerListElement[]>(url + '/AnsprechPartnerByAddressID?AdressID=' + adressID, this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo)).subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: () => reject()
            });
        });
    }

    getCityByZip(zip: string): Promise<AdresseModels.Ort> {
        return new Promise((resolve) => {
            const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
            let resultEmpty: AdresseModels.Ort = {
                country: '', zip: '', town: '', canton: '',
            };
            let cities: AdresseModels.Ort[] = [];
            this.http
                .get<AdresseModels.Ort[]>(url + '/GetCitiesByZIP?ZIP=' + zip, this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo))
                .subscribe({
                    next: (res) => {
                        if (res) {
                            cities = res;
                            if (cities.length > 1) {
                                var dialogRef = this.dialog.open(OrtAuswahlComponent, {
                                    disableClose: false, width: '400px', data: cities,
                                });

                                dialogRef.afterClosed().subscribe({
                                    next: (result) => {
                                        if (result) {
                                            resolve(result);
                                        } else {
                                            resolve(result);
                                        }
                                    },
                                });
                            } else if (cities.length === 1) {
                                resolve(res[0]);
                            } else {
                                resolve(resultEmpty);
                            }
                        }
                    }, error: (error) => {
                        console.error('Fehler beim Ermitteln einer Ortschaft', zip, error);
                        return resultEmpty;
                    },
                });
        });
    }

    getObjectListFelder(): Promise<AdresseModels.ObjektListField[]> {
        return new Promise((resolve) => {
            if (this.objectListFields.length === 0) {
                this.getObjectListFields().subscribe({
                    next: (res) => {
                        this.objectListFields = res.filter((x) => x.visible);
                        resolve(this.objectListFields);
                    }, error: (err) => {
                        console.error('Fehler bei der Ermittlung der Objekt-Felder für die Adressen', err);
                    },
                });
            } else {
                resolve(this.objectListFields);
            }
        });
    }

    async getObjectList(adressID: string): Promise<AdresseModels.ObjektListElement[]> {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return new Promise((resolve, reject) => {
            this.http.get<AdresseModels.ObjektListElement[]>(url + '/ObjektListByAddressID?AdressID=' + adressID, this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo)).subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: () => {
                    reject();
                }
            });
        });
    }

    public getDefaultCountry(): AdresseModels.Country {
        let country: AdresseModels.Country;
        if (this.laender) {
            country = this.laender.filter((country) => country.isoShort === 'CH')[0];
        } else {
            country = {
                isoShort: 'CH', isoNameInternational: 'Schweiz', isoNameNational: 'Schweiz', isoCurrency: 'CHF', isoLanguage: 'D',
            };
        }
        return country;
    }

    newAdresse(currAdresse: AdresseModels.DetailAdresseElement) {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.post<AdresseModels.DetailAdresseElement>(url + '/NewAdresse', currAdresse, this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo));
    }

    updateAdresse(currAdresse: AdresseModels.DetailAdresseElement) {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.post<AdresseModels.DetailAdresseElement>(url + '/UpdateAdresse', currAdresse, this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo));
    }

    deleteAdresse(currAdresse: AdresseModels.DetailAdresseElement) {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http
            .post<AdresseModels.DetailAdresseElement>(url + '/DelAdresse', currAdresse, this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo))
            .subscribe({
                next: (res) => console.log(res), error: (err) => {
                    this.translate.get('MAIN_APP_DIALOG.ERROR_DIALOG.DELETE_NOT_POSSIIBLE.text').subscribe((t: string) => {
                        this.svcMessageBox.showError(t, '');
                    });
                    console.log(err);
                },
            });
    }

    public async deleteAddress(currAdresse: AdresseModels.DetailAdresseElement) {
        return new Promise((resolve, reject) => {
            const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
            return this.http.post<AdresseModels.DetailAdresseElement>(url + '/DelAdresse', currAdresse, this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo)).subscribe({
                next: (res) => resolve(res), error: () => {
                    reject();
                },
            });
        });
    }

    public async deleteAddressByID(addressID: string) {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json', Authorization: this.helperService.getSwissAuthorization(this.userAuthService.currentUserInfo),
        });

        const params: HttpParams = new HttpParams().set('adressID', addressID);

        const options = {
            headers: headers, params: params,
        };
        return this.http.post<AdresseModels.DetailAdresseElement>(url + '/DelAdresseByID', {}, options);
    }

    newAdressPartner(currAdresse: AdresseModels.AnsprechPartnerElement, parentAdress: string) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json', Authorization: this.helperService.getSwissAuthorization(this.userAuthService.currentUserInfo),
        });

        const params: HttpParams = new HttpParams().set('parentAdress', parentAdress); // Hauptadresse der Partner

        const options = {
            headers: headers, params: params,
        };

        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.post<AdresseModels.AnsprechPartnerElement>(url + '/NewAnsprechPartner', currAdresse, options);
    }

    updateAdressPartner(currAdressPartner: any[], parentAdress: string) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json', Authorization: this.helperService.getSwissAuthorization(this.userAuthService.currentUserInfo),
        });

        const params: HttpParams = new HttpParams().set('parentAdress', parentAdress); // Hauptadresse der Partner

        const options = {
            headers: headers, params: params,
        };

        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.post<AdresseModels.AnsprechPartnerListElement[]>(url + '/UpdateAnsprechPartner', currAdressPartner, options);
    }

    deleteAdressPartner(ansprechPartnerAdressID: string) {
        const formData = new FormData();
        const headers = new HttpHeaders({
            Authorization: this.helperService.getSwissAuthorization(this.userAuthService.currentUserInfo),
        });
        const params: HttpParams = new HttpParams().set('ansprechPartnerAdressID', ansprechPartnerAdressID);

        const options = {
            headers: headers, params: params,
        };

        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.post<Response>(url + '/DelAnsprechPartner', formData, options);
    }

    public delObjectAddress(objectID: string, addressID: string, contactID: string): Promise<boolean> {
        const formData = new FormData();
        const headers = new HttpHeaders({
            Authorization: this.helperService.getSwissAuthorization(this.userAuthService.currentUserInfo),
        });
        const params: HttpParams = new HttpParams().set('objectID', objectID).set('addressID', addressID).set('contactID', contactID);

        const options = {
            headers: headers, params: params,
        };
        const url = this.helperService.getSwissWebServiceConfig()!.objUrl;

        return new Promise((resolve, reject) => {
            return this.http.post<Response>(url + '/DeleteObjektAdressZuordByAddressID', formData, options).subscribe({
                next: () => resolve(true), error: () => reject()
            });
        });
    }

    public searchAddress(searchValue: string, showInactive = false, offset = 0, limit = 25) {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.get<AdresseModels.AddressSearch>(url +
            '/Search?Mandator=' + this.userAuthService.getCurrentAuthenticatedUser()?.mandatorID
            + '&Search=' + searchValue
            + '&ShowInactive=' + showInactive
            + '&Limit=' + limit
            + '&Offset=' + offset,
            this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo));
    }

    private getObjectListFields(): Observable<AdresseModels.ObjektListField[]> {
        const url = this.helperService.getSwissWebServiceConfig()!.adrUrl;
        return this.http.get<AdresseModels.ObjektListField[]>(url + '/ObjektListFields', this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo));
    }
}
